export default {
  CL_BudBlob: {
    src: new URL(
      "./BudBlob.png?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./BudBlob.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./BudBlob.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./BudBlob.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./BudBlob.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./BudBlob.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./BudBlob.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  CL_Venturecoral: {
    src: new URL(
      "./VentureCoral.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./VentureCoral.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./VentureCoral.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./VentureCoral.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./VentureCoral.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./VentureCoral.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./VentureCoral.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  FT_Swellberries: {
    src: new URL(
      "./Swellberries.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Swellberries.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Swellberries.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Swellberries.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./Swellberries.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Swellberries.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Swellberries.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  FT_Multipod: {
    src: new URL(
      "./Multipod.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Multipod.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Multipod.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Multipod.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./Multipod.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Multipod.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Multipod.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  FF_Rotwood: {
    src: new URL(
      "./Rotwood.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Rotwood.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Rotwood.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Rotwood.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./Rotwood.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Rotwood.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Rotwood.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  FF_Chainshrooms: {
    src: new URL(
      "./Chainshrooms.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Chainshrooms.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Chainshrooms.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Chainshrooms.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      png: `${
        new URL(
          "./Chainshrooms.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Chainshrooms.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Chainshrooms.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
};
